import { isRouteErrorResponse, useRouteError } from '@/shared/modern-router';

export const ErrorBoundary = () => {
  const error = useRouteError() as
    | {
        statusText: string;
        status: number;
        message?: string;
      }
    | string;

  return isRouteErrorResponse(error) ? (
    <h1>
      {error.status} {error.statusText}
    </h1>
  ) : (
    <h1>
      {typeof error === 'object' && error.message
        ? error.message
        : typeof error === 'string' && error}
    </h1>
  );
};
